var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.3301C11.4991 22.3305 11.0065 22.2016 10.5699 21.9558C10.1333 21.71 9.76761 21.3557 9.50815 20.9271L1.39815 7.39008C1.14054 6.94963 1.00311 6.44927 0.999581 5.93904C0.996056 5.42881 1.12657 4.92659 1.37806 4.48263C1.62955 4.03867 1.99321 3.66853 2.43266 3.40923C2.8721 3.14993 3.37193 3.01057 3.88215 3.00508H20.1071C20.6169 3.00867 21.1168 3.14594 21.5569 3.40316C21.9971 3.66039 22.362 4.02857 22.6153 4.47095C22.8687 4.91333 23.0015 5.41443 23.0006 5.92421C22.9997 6.43398 22.865 6.9346 22.6101 7.37608L14.4941 20.9221C14.2344 21.3512 13.8685 21.7062 13.4316 21.9528C12.9948 22.1995 12.5018 22.3294 12.0001 22.3301Z",
    fill: "#FF816E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccordion);
export default __webpack_public_path__ + "static/media/icon_Accordion.07b8244cd487d667492a108df532d5d8.svg";
export { ForwardRef as ReactComponent };